import * as tslib_1 from "tslib";
import removeSyncRequestOperation from 'owa-service/lib/operation/removeSyncRequestOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function removeSyncRequest(syncRequest) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: getJsonRequestHeader(),
                        Id: syncRequest.Id,
                    };
                    return [4 /*yield*/, removeSyncRequestOperation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=removeSyncRequest.js.map